module.exports = __webpack_public_path__ + "assets/img/logo.ce9a537f.png";